import { useTheme } from '@emotion/react';
import cn from 'classnames';

import { IConDefaultType } from '../types';

export enum WarningIconVariant {
  DEFAULT = 'default',
  LINED = 'lined',
  WARNING3 = 'warning3',
}

interface IWarningIconProps extends IConDefaultType {
  variant?: WarningIconVariant;
}

function WarningIcon({
  className,
  size = 24,
  rotate,
  flip,
  color,
  variant = WarningIconVariant.DEFAULT,
}: IWarningIconProps) {
  const theme = useTheme();

  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === WarningIconVariant.DEFAULT && (
        <svg height={'100%'} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12.7188" cy="12.2539" r="10" fill={color || theme.color.static.warning} />
          <path
            d="M12.7195 15.2637C13.0565 15.2637 13.3511 15.3868 13.6013 15.6338C13.8512 15.8807 13.9763 16.1714 13.9763 16.5039C13.9761 16.8362 13.8512 17.1263 13.6013 17.373C13.3511 17.62 13.0564 17.7441 12.7195 17.7441C12.3827 17.7441 12.0887 17.6198 11.8386 17.373C11.5887 17.1262 11.4638 16.8362 11.4636 16.5039C11.4636 16.1512 11.5833 15.856 11.823 15.6191C12.063 15.3823 12.3621 15.2638 12.7195 15.2637ZM12.7205 6.76172C13.3024 6.76185 13.721 6.92453 13.9763 7.24707C14.2314 7.56954 14.3286 7.88225 14.2673 8.18457L13.0876 14.083C13.0874 14.1532 13.0442 14.2042 12.9578 14.2344C12.8712 14.2645 12.7918 14.2802 12.7205 14.2803C12.6389 14.2803 12.556 14.2673 12.4744 14.2422C12.3931 14.217 12.347 14.1633 12.3367 14.083L11.1726 8.18457C11.1011 7.87204 11.1883 7.55682 11.4333 7.23926C11.6785 6.92172 12.1076 6.76172 12.7205 6.76172Z"
            fill="white"
          />
        </svg>
      )}
      {variant === WarningIconVariant.LINED && (
        <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 0 24 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            fill={color || theme.color.static.warning}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.3941 13.9445L13.6477 7.67725C13.7128 7.35585 13.6097 7.02374 13.3383 6.68092C13.067 6.3381 12.622 6.16669 12.0033 6.16669C11.3521 6.16669 10.8962 6.33542 10.6358 6.67289C10.3753 7.01035 10.283 7.34514 10.359 7.67725L11.5963 13.9445C11.6072 14.0302 11.656 14.0864 11.7428 14.1132C11.8297 14.14 11.9165 14.1534 12.0033 14.1534C12.0793 14.1534 12.1634 14.1373 12.2557 14.1052C12.3479 14.073 12.3941 14.0195 12.3941 13.9445ZM12.9396 17.4396C13.2055 17.1771 13.3384 16.8691 13.3384 16.5156C13.3384 16.1621 13.2055 15.8541 12.9396 15.5916C12.6737 15.3291 12.3616 15.1979 12.0034 15.1979C11.6235 15.1979 11.3061 15.3238 11.051 15.5755C10.7959 15.8273 10.6684 16.1406 10.6684 16.5156C10.6684 16.8691 10.8014 17.1771 11.0673 17.4396C11.3332 17.7021 11.6453 17.8333 12.0034 17.8333C12.3616 17.8333 12.6737 17.7021 12.9396 17.4396Z"
            fill={color || theme.color.static.warning}
          />
        </svg>
      )}
      {variant === WarningIconVariant.WARNING3 && (
        <svg height="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.99992 13.3335C10.9454 13.3335 13.3333 10.9457 13.3333 8.00016C13.3333 5.05464 10.9454 2.66683 7.99992 2.66683C5.0544 2.66683 2.66659 5.05464 2.66659 8.00016C2.66659 10.9457 5.0544 13.3335 7.99992 13.3335ZM7.99992 14.6668C11.6818 14.6668 14.6666 11.6821 14.6666 8.00016C14.6666 4.31826 11.6818 1.3335 7.99992 1.3335C4.31802 1.3335 1.33325 4.31826 1.33325 8.00016C1.33325 11.6821 4.31802 14.6668 7.99992 14.6668Z"
            fill={color || theme.color.static.warning}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.26263 9.29647L9.09837 5.11833C9.14179 4.90406 9.07305 4.68266 8.89215 4.45411C8.71125 4.22556 8.41458 4.11129 8.00214 4.11129C7.56799 4.11129 7.26408 4.22378 7.09042 4.44875C6.91676 4.67373 6.85526 4.89692 6.90591 5.11833L7.7308 9.29647C7.73803 9.35361 7.77059 9.3911 7.82848 9.40896C7.88637 9.42682 7.94425 9.43574 8.00214 9.43574C8.05279 9.43574 8.10887 9.42503 8.17037 9.4036C8.23188 9.38218 8.26263 9.34647 8.26263 9.29647ZM8.6263 11.6266C8.80357 11.4516 8.89221 11.2463 8.89221 11.0106C8.89221 10.7749 8.80357 10.5695 8.6263 10.3946C8.44902 10.2196 8.24099 10.1321 8.0022 10.1321C7.74895 10.1321 7.5373 10.216 7.36726 10.3838C7.19722 10.5517 7.1122 10.7606 7.1122 11.0106C7.1122 11.2463 7.20083 11.4516 7.37811 11.6266C7.55539 11.8016 7.76342 11.8891 8.0022 11.8891C8.24099 11.8891 8.44902 11.8016 8.6263 11.6266Z"
            fill={color || theme.color.static.warning}
          />
        </svg>
      )}
    </i>
  );
}

export default WarningIcon;
